import { useEffect } from 'react'

import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { ApplicationState } from '@store/types'
import { Button } from '@interco/inter-ui/components/Button'
import { Page } from '@templates'
import { Timer } from '@signals'
import { useTrackingRefin } from '@hooks'
import { StepRefin } from '@utils/enums'
import Tag from '@utils/Tag'
import routes from '@routes/routes'

import { Content, IconWrapper, Title, Subtitle } from './styles'

const INSSIndisponivel = () => {
  const navigate = useNavigate()
  const { isApp } = useSelector((state: ApplicationState) => state.ui.navigation)

  useTrackingRefin(StepRefin.INSS_INDISPONIVEL)

  useEffect(() => {
    if (isApp) {
      Tag.enviarTagueamentoApp({
        screen: 'clt:refin:feedback',
        ref_type: '',
        content_action: 'Dado carregado',
        action_id: 'INSS temporariamente indisponível',
        section: 'feedback',
        sub_section: '',
        step: '',
        scenario: 'unavailable',
        ref_figma: '2',
      })
    } else {
      Tag.enviarTagueamentoWeb({
        element_action: 'page_loaded',
        element_name: 'INSS temporariamente indisponível',
        c_page: window.location.href,
        redirect_url: '',
        section_name: 'payrollloan:refin:feedback',
        section: 'feedback',
        sub_section: '',
        step: '',
        scenario: 'unavailable',
      })
    }
  }, [isApp])

  return (
    <Page
      showLeftIcon={false}
      stickyFooter={
        <Button
          variant="primary"
          aria-label="Ir para a home"
          onClick={() => {
            navigate(routes.ROOT)
          }}
        >
          Ir para a home
        </Button>
      }
    >
      <Content>
        <IconWrapper aria-hidden="true">
          <Timer />
        </IconWrapper>
        <Title>INSS temporariamente indisponível</Title>
        <Subtitle>
          Suspendemos as contratações do Consignado INSS. Avisaremos quando voltar.
        </Subtitle>
      </Content>
    </Page>
  )
}

export default INSSIndisponivel
